import svgAddressBookTabs from '@components/icons/svgs/address-book-tabs';
import svgAdministracaoDeDrogas from '@components/icons/svgs/administracao-de-drogas';
import svgAirplay from '@components/icons/svgs/airplay';
import svgAlignBottom from '@components/icons/svgs/align-bottom';
import svgAlignCenterHorizontal from '@components/icons/svgs/align-center-horizontal';
import svgAlignCenterVertical from '@components/icons/svgs/align-center-vertical';
import svgAlignLeft from '@components/icons/svgs/align-left';
import svgAlignRight from '@components/icons/svgs/align-right';
import svgAlignTop from '@components/icons/svgs/align-top';
import svgAmerican from '@components/icons/svgs/american';
import svgAnestesiologia from '@components/icons/svgs/anestesiologia';
import svgArmchair from '@components/icons/svgs/armchair';
import svgArrowArcLeft from '@components/icons/svgs/arrow-arc-left';
import svgArrowArcRight from '@components/icons/svgs/arrow-arc-right';
import svgArrowBendUpLeft from '@components/icons/svgs/arrow-bend-up-left';
import svgArrowBendUpRight from '@components/icons/svgs/arrow-bend-up-right';
import svgArrowClockwise from '@components/icons/svgs/arrow-clockwise';
import svgArrowCounterClockwise from '@components/icons/svgs/arrow-counter-clockwise';
import svgArrowDownLeft from '@components/icons/svgs/arrow-down-left';
import svgArrowDownRight from '@components/icons/svgs/arrow-down-right';
import svgArrowDown from '@components/icons/svgs/arrow-down';
import svgArrowElbowDownLeft from '@components/icons/svgs/arrow-elbow-down-left';
import svgArrowElbowDownRight from '@components/icons/svgs/arrow-elbow-down-right';
import svgArrowElbowUpLeft from '@components/icons/svgs/arrow-elbow-up-left';
import svgArrowElbowUpRight from '@components/icons/svgs/arrow-elbow-up-right';
import svgArrowLeft from '@components/icons/svgs/arrow-left';
import svgArrowRight from '@components/icons/svgs/arrow-right';
import svgArrowSquareOut from '@components/icons/svgs/arrow-square-out';
import svgArrowUpLeft from '@components/icons/svgs/arrow-up-left';
import svgArrowUpRight from '@components/icons/svgs/arrow-up-right';
import svgArrowUp from '@components/icons/svgs/arrow-up';
import svgArrowsClockwise from '@components/icons/svgs/arrows-clockwise';
import svgArrowsCounterClockwise from '@components/icons/svgs/arrows-counter-clockwise';
import svgArrowsDownUp from '@components/icons/svgs/arrows-down-up';
import svgArrowsInLineVertical from '@components/icons/svgs/arrows-in-line-vertical';
import svgArrowsInSimple from '@components/icons/svgs/arrows-in-simple';
import svgArrowsLeftRight from '@components/icons/svgs/arrows-left-right';
import svgArrowsOutCardinal from '@components/icons/svgs/arrows-out-cardinal';
import svgArrowsOutLineVertical from '@components/icons/svgs/arrows-out-line-vertical';
import svgArrowsOutSimple from '@components/icons/svgs/arrows-out-simple';
import svgArrowsOut from '@components/icons/svgs/arrows-out';
import svgAt from '@components/icons/svgs/at';
import svgAtlasDeDermatologia from '@components/icons/svgs/atlas-de-dermatologia';
import svgAtlasDeRadiologia from '@components/icons/svgs/atlas-de-radiologia';
import svgAtlasOftalmologia from '@components/icons/svgs/atlas-oftalmologia';
import svgAtlasOrtopedia from '@components/icons/svgs/atlas-ortopedia';
import svgBaby from '@components/icons/svgs/baby';
import svgBarcode from '@components/icons/svgs/barcode';
import svgBasket from '@components/icons/svgs/basket';
import svgBatteryCharging from '@components/icons/svgs/battery-charging';
import svgBatteryFull from '@components/icons/svgs/battery-full';
import svgBatteryHigh from '@components/icons/svgs/battery-high';
import svgBatteryLow from '@components/icons/svgs/battery-low';
import svgBatteryMedium from '@components/icons/svgs/battery-medium';
import svgBellRinging from '@components/icons/svgs/bell-ringing';
import svgBellSlash from '@components/icons/svgs/bell-slash';
import svgBellZ from '@components/icons/svgs/bell-z';
import svgBell from '@components/icons/svgs/bell';
import svgBluetoothOff from '@components/icons/svgs/bluetooth-off';
import svgBluetooth from '@components/icons/svgs/bluetooth';
import svgBookOpenText from '@components/icons/svgs/book-open-text';
import svgBook from '@components/icons/svgs/book';
import svgBookmarkSimple from '@components/icons/svgs/bookmark-simple';
import svgBroom from '@components/icons/svgs/broom';
import svgBrowsers from '@components/icons/svgs/browsers';
import svgBuildingOffice from '@components/icons/svgs/building-office';
import svgBuildings from '@components/icons/svgs/buildings';
import svgCalculadorasEscores from '@components/icons/svgs/calculadoras-escores';
import svgCalculadorasObstetricas from '@components/icons/svgs/calculadoras-obstetricas';
import svgCalculadorasPediatricas from '@components/icons/svgs/calculadoras-pediatricas';
import svgCalendarBlank from '@components/icons/svgs/calendar-blank';
import svgCalendarCheck from '@components/icons/svgs/calendar-check';
import svgCalendarDots from '@components/icons/svgs/calendar-dots';
import svgCalendarPlus from '@components/icons/svgs/calendar-plus';
import svgCalendarSlash from '@components/icons/svgs/calendar-slash';
import svgCameraRotate from '@components/icons/svgs/camera-rotate';
import svgCameraSlash from '@components/icons/svgs/camera-slash';
import svgCamera from '@components/icons/svgs/camera';
import svgCardholder from '@components/icons/svgs/cardholder';
import svgCardsThree from '@components/icons/svgs/cards-three';
import svgCaretDown from '@components/icons/svgs/caret-down';
import svgCaretLeft from '@components/icons/svgs/caret-left';
import svgCaretRight from '@components/icons/svgs/caret-right';
import svgCaretUpDown from '@components/icons/svgs/caret-up-down';
import svgCaretUp from '@components/icons/svgs/caret-up';
import svgCellSignalFull from '@components/icons/svgs/cell-signal-full';
import svgCellSignalOff from '@components/icons/svgs/cell-signal-off';
import svgChartBarHorizontal from '@components/icons/svgs/chart-bar-horizontal';
import svgChartBar from '@components/icons/svgs/chart-bar';
import svgChartDonut from '@components/icons/svgs/chart-donut';
import svgChartLineDown from '@components/icons/svgs/chart-line-down';
import svgChartLineUp from '@components/icons/svgs/chart-line-up';
import svgChartPieSlice from '@components/icons/svgs/chart-pie-slice';
import svgChartScatter from '@components/icons/svgs/chart-scatter';
import svgChatCircleDots from '@components/icons/svgs/chat-circle-dots';
import svgChatCircle from '@components/icons/svgs/chat-circle';
import svgChatTeardropSlash from '@components/icons/svgs/chat-teardrop-slash';
import svgChatsCircle from '@components/icons/svgs/chats-circle';
import svgCheckCircle from '@components/icons/svgs/check-circle';
import svgCheck from '@components/icons/svgs/check';
import svgCheckboxFill from '@components/icons/svgs/checkbox-fill';
import svgCheckbox from '@components/icons/svgs/checkbox';
import svgChecks from '@components/icons/svgs/checks';
import svgCid from '@components/icons/svgs/cid';
import svgCircleNotch from '@components/icons/svgs/circle-notch';
import svgCircuitry from '@components/icons/svgs/circuitry';
import svgClinicalDrops from '@components/icons/svgs/clinical-drops';
import svgClockCountdownFill from '@components/icons/svgs/clock-countdown-fill';
import svgClockCountdown from '@components/icons/svgs/clock-countdown';
import svgClockCounterClockwise from '@components/icons/svgs/clock-counter-clockwise';
import svgClockFill from '@components/icons/svgs/clock-fill';
import svgClock from '@components/icons/svgs/clock';
import svgClose from '@components/icons/svgs/close';
import svgClosedCaptioning from '@components/icons/svgs/closed-captioning';
import svgCloudArrowDown from '@components/icons/svgs/cloud-arrow-down';
import svgCloudArrowUp from '@components/icons/svgs/cloud-arrow-up';
import svgCloudSlash from '@components/icons/svgs/cloud-slash';
import svgCloud from '@components/icons/svgs/cloud';
import svgCodigoDeEtica from '@components/icons/svgs/codigo-de-etica';
import svgCoins from '@components/icons/svgs/coins';
import svgCompass from '@components/icons/svgs/compass';
import svgCondutasCirurgicas from '@components/icons/svgs/condutas-cirurgicas';
import svgCondutasGinecologicas from '@components/icons/svgs/condutas-ginecologicas';
import svgCondutasPediatricas from '@components/icons/svgs/condutas-pediatricas';
import svgContactlessPayment from '@components/icons/svgs/contactless-payment';
import svgCookie from '@components/icons/svgs/cookie';
import svgCopy from '@components/icons/svgs/copy';
import svgCopyright from '@components/icons/svgs/copyright';
import svgCornersOut from '@components/icons/svgs/corners-out';
import svgCouch from '@components/icons/svgs/couch';
import svgCreditCard from '@components/icons/svgs/credit-card';
import svgCriteriosDiagnosticos from '@components/icons/svgs/criterios-diagnosticos';
import svgCrop from '@components/icons/svgs/crop';
import svgCrownSimple from '@components/icons/svgs/crown-simple';
import svgCube from '@components/icons/svgs/cube';
import svgCuidadosPaleativos from '@components/icons/svgs/cuidados-paleativos';
import svgCurrencyBtc from '@components/icons/svgs/currency-btc';
import svgCurrencyCircleDollarFill from '@components/icons/svgs/currency-circle-dollar-fill';
import svgCurrencyCircleDollar from '@components/icons/svgs/currency-circle-dollar';
import svgCurrencyDollarSimple from '@components/icons/svgs/currency-dollar-simple';
import svgCurrencyEur from '@components/icons/svgs/currency-eur';
import svgCurrencyGbp from '@components/icons/svgs/currency-gbp';
import svgCursorText from '@components/icons/svgs/cursor-text';
import svgCursor from '@components/icons/svgs/cursor';
import svgDatabase from '@components/icons/svgs/database';
import svgDecisionTracks from '@components/icons/svgs/decision-tracks';
import svgDesktop from '@components/icons/svgs/desktop';
import svgDeviceMobileSpeaker from '@components/icons/svgs/device-mobile-speaker';
import svgDeviceTabletSpeaker from '@components/icons/svgs/device-tablet-speaker';
import svgDevices from '@components/icons/svgs/devices';
import svgDiagnosticoDiferencial from '@components/icons/svgs/diagnostico-diferencial';
import svgDinners from '@components/icons/svgs/dinners';
import svgDocumentosAtestados from '@components/icons/svgs/documentos-atestados';
import svgDotsSixVertical from '@components/icons/svgs/dots-six-vertical';
import svgDotsSix from '@components/icons/svgs/dots-six';
import svgDotsThreeVertical from '@components/icons/svgs/dots-three-vertical';
import svgDotsThree from '@components/icons/svgs/dots-three';
import svgDownloadSimple from '@components/icons/svgs/download-simple';
import svgDragHandle from '@components/icons/svgs/drag-handle';
import svgDrop from '@components/icons/svgs/drop';
import svgEarSlash from '@components/icons/svgs/ear-slash';
import svgEject from '@components/icons/svgs/eject';
import svgElo from '@components/icons/svgs/elo';
import svgEmergenciasUti from '@components/icons/svgs/emergencias-uti';
import svgEnvelopeOpen from '@components/icons/svgs/envelope-open';
import svgEnvelopeSimple from '@components/icons/svgs/envelope-simple';
import svgEqualizer from '@components/icons/svgs/equalizer';
import svgEraser from '@components/icons/svgs/eraser';
import svgExamesComplementares from '@components/icons/svgs/exames-complementares';
import svgExport from '@components/icons/svgs/export';
import svgEyeClosed from '@components/icons/svgs/eye-closed';
import svgEyeSlash from '@components/icons/svgs/eye-slash';
import svgEye from '@components/icons/svgs/eye';
import svgEyedropperSample from '@components/icons/svgs/eyedropper-sample';
import svgEyedropper from '@components/icons/svgs/eyedropper';
import svgFactory from '@components/icons/svgs/factory';
import svgFastForward from '@components/icons/svgs/fast-forward';
import svgFilePlus from '@components/icons/svgs/file-plus';
import svgFileText from '@components/icons/svgs/file-text';
import svgFile from '@components/icons/svgs/file';
import svgFilmReel from '@components/icons/svgs/film-reel';
import svgFilmSlate from '@components/icons/svgs/film-slate';
import svgFilmStrip from '@components/icons/svgs/film-strip';
import svgFingerprint from '@components/icons/svgs/fingerprint';
import svgFlag from '@components/icons/svgs/flag';
import svgFlipHorizontal from '@components/icons/svgs/flip-horizontal';
import svgFlipVertical from '@components/icons/svgs/flip-vertical';
import svgFolderOpen from '@components/icons/svgs/folder-open';
import svgFolderPlus from '@components/icons/svgs/folder-plus';
import svgFolderSimpleLock from '@components/icons/svgs/folder-simple-lock';
import svgFolder from '@components/icons/svgs/folder';
import svgFrameCorners from '@components/icons/svgs/frame-corners';
import svgFunnelSimpleX from '@components/icons/svgs/funnel-simple-x';
import svgFunnelSimple from '@components/icons/svgs/funnel-simple';
import svgFunnelX from '@components/icons/svgs/funnel-x';
import svgFunnel from '@components/icons/svgs/funnel';
import svgGaugeFill from '@components/icons/svgs/gauge-fill';
import svgGauge from '@components/icons/svgs/gauge';
import svgGear from '@components/icons/svgs/gear';
import svgGenderFemale from '@components/icons/svgs/gender-female';
import svgGenderIntersex from '@components/icons/svgs/gender-intersex';
import svgGenderMale from '@components/icons/svgs/gender-male';
import svgGenderNeuter from '@components/icons/svgs/gender-neuter';
import svgGenderNonbinary from '@components/icons/svgs/gender-nonbinary';
import svgGenderTransgender from '@components/icons/svgs/gender-transgender';
import svgGerenciadorDePlantao from '@components/icons/svgs/gerenciador-de-plantao';
import svgGift from '@components/icons/svgs/gift';
import svgGlobeHemisphereWest from '@components/icons/svgs/globe-hemisphere-west';
import svgGlobe from '@components/icons/svgs/globe';
import svgGlossario from '@components/icons/svgs/glossario';
import svgGpsFix from '@components/icons/svgs/gps-fix';
import svgGpsSlash from '@components/icons/svgs/gps-slash';
import svgGuiaDeAntimicrobianos from '@components/icons/svgs/guia-de-antimicrobianos';
import svgGuiaDeEcg from '@components/icons/svgs/guia-de-ecg';
import svgGuiaDeProcedimentos from '@components/icons/svgs/guia-de-procedimentos';
import svgGuiaDeVm from '@components/icons/svgs/guia-de-vm';
import svgGuiaIntoxicacao from '@components/icons/svgs/guia-intoxicacao';
import svgGuiaUsgBeiraLeito from '@components/icons/svgs/guia-usg-beira-leito';
import svgHandPointing from '@components/icons/svgs/hand-pointing';
import svgHardDrives from '@components/icons/svgs/hard-drives';
import svgHeadphones from '@components/icons/svgs/headphones';
import svgHeartHalf from '@components/icons/svgs/heart-half';
import svgHeart from '@components/icons/svgs/heart';
import svgHourglassMediumFill from '@components/icons/svgs/hourglass-medium-fill';
import svgHourglassMedium from '@components/icons/svgs/hourglass-medium';
import svgHouse from '@components/icons/svgs/house';
import svgImage from '@components/icons/svgs/image';
import svgImagesSquare from '@components/icons/svgs/images-square';
import svgInfo from '@components/icons/svgs/info';
import svgInfusao from '@components/icons/svgs/infusao';
import svgInteracaoMedicamentosa from '@components/icons/svgs/interacao-medicamentosa';
import svgIntercorrenciasObstetricias from '@components/icons/svgs/intercorrencias-obstetricias';
import svgKey from '@components/icons/svgs/key';
import svgKeyhole from '@components/icons/svgs/keyhole';
import svgLaboratorio from '@components/icons/svgs/laboratorio';
import svgLaptop from '@components/icons/svgs/laptop';
import svgLightbulbFilament from '@components/icons/svgs/lightbulb-filament';
import svgLightningSlash from '@components/icons/svgs/lightning-slash';
import svgLightning from '@components/icons/svgs/lightning';
import svgLinkBreak from '@components/icons/svgs/link-break';
import svgLink from '@components/icons/svgs/link';
import svgList from '@components/icons/svgs/list';
import svgListBullets from '@components/icons/svgs/list-bullets';
import svgLockKeyOpen from '@components/icons/svgs/lock-key-open';
import svgLockKey from '@components/icons/svgs/lock-key';
import svgLogoWb from '@components/icons/svgs/logo-wb';
import svgMagicWand from '@components/icons/svgs/magic-wand';
import svgMagnifyingGlassMinus from '@components/icons/svgs/magnifying-glass-minus';
import svgMagnifyingGlassPlus from '@components/icons/svgs/magnifying-glass-plus';
import svgMagnifyingGlass from '@components/icons/svgs/magnifying-glass';
import svgManipulados from '@components/icons/svgs/manipulados';
import svgMapPinArea from '@components/icons/svgs/map-pin-area';
import svgMapPin from '@components/icons/svgs/map-pin';
import svgMapTrifold from '@components/icons/svgs/map-trifold';
import svgMaster from '@components/icons/svgs/master';
import svgMedicamentos from '@components/icons/svgs/medicamentos';
import svgMedicinaDeFamilia from '@components/icons/svgs/medicina-de-familia';
import svgMedicinaEsporte from '@components/icons/svgs/medicina-esporte';
import svgMedicinaInterna from '@components/icons/svgs/medicina-interna';
import svgMegaphone from '@components/icons/svgs/megaphone';
import svgMicrophoneSlash from '@components/icons/svgs/microphone-slash';
import svgMicrophone from '@components/icons/svgs/microphone';
import svgMinusCircle from '@components/icons/svgs/minus-circle';
import svgMinus from '@components/icons/svgs/minus';
import svgMoon from '@components/icons/svgs/moon';
import svgMouse from '@components/icons/svgs/mouse';
import svgMusicNotes from '@components/icons/svgs/music-notes';
import svgNavigationArrow from '@components/icons/svgs/navigation-arrow';
import svgNewspaperClipping from '@components/icons/svgs/newspaper-clipping';
import svgNotches from '@components/icons/svgs/notches';
import svgNoteBlank from '@components/icons/svgs/note-blank';
import svgNotePencil from '@components/icons/svgs/note-pencil';
import svgNote from '@components/icons/svgs/note';
import svgNumpad from '@components/icons/svgs/numpad';
import svgNut from '@components/icons/svgs/nut';
import svgOftalmologia from '@components/icons/svgs/oftalmologia';
import svgOrientacaoAoPaciente from '@components/icons/svgs/orientacao-ao-paciente';
import svgOrtopedia from '@components/icons/svgs/ortopedia';
import svgOtorrinolaringologia from '@components/icons/svgs/otorrinolaringologia';
import svgPackage from '@components/icons/svgs/package';
import svgPaintBrushBroad from '@components/icons/svgs/paint-brush-broad';
import svgPaintBucket from '@components/icons/svgs/paint-bucket';
import svgPaintRoller from '@components/icons/svgs/paint-roller';
import svgPalette from '@components/icons/svgs/palette';
import svgPaperPlaneTilt from '@components/icons/svgs/paper-plane-tilt';
import svgPaperclip from '@components/icons/svgs/paperclip';
import svgParagraph from '@components/icons/svgs/paragraph';
import svgPartoEpuerperio from '@components/icons/svgs/parto-epuerperio';
import svgPauseCircle from '@components/icons/svgs/pause-circle';
import svgPause from '@components/icons/svgs/pause';
import svgPencilSimple from '@components/icons/svgs/pencil-simple';
import svgPhoneCall from '@components/icons/svgs/phone-call';
import svgPhoneDisconnect from '@components/icons/svgs/phone-disconnect';
import svgPhoneOutgoing from '@components/icons/svgs/phone-outgoing';
import svgPhoneSlash from '@components/icons/svgs/phone-slash';
import svgPhoneTransfer from '@components/icons/svgs/phone-transfer';
import svgPhoneX from '@components/icons/svgs/phone-x';
import svgPiggyBank from '@components/icons/svgs/piggy-bank';
import svgPlayCircle from '@components/icons/svgs/play-circle';
import svgPlayPause from '@components/icons/svgs/play-pause';
import svgPlay from '@components/icons/svgs/play';
import svgPlaylist from '@components/icons/svgs/playlist';
import svgPlusCircle from '@components/icons/svgs/plus-circle';
import svgPlus from '@components/icons/svgs/plus';
import svgPodcast from '@components/icons/svgs/podcast';
import svgPower from '@components/icons/svgs/power';
import svgPreNatal from '@components/icons/svgs/pre-natal';
import svgPrescicoesCirurgicas from '@components/icons/svgs/prescicoes-cirurgicas';
import svgPrescricao from '@components/icons/svgs/prescricao';
import svgPrescricoesPediatricas from '@components/icons/svgs/prescricoes-pediatricas';
import svgPrescritorDeAntibiotico from '@components/icons/svgs/prescritor-de-antibiotico';
import svgProcedimentosPediatricos from '@components/icons/svgs/procedimentos-pediatricos';
import svgProdutosFarmaceuticos from '@components/icons/svgs/produtos-farmaceuticos';
import svgProhibit from '@components/icons/svgs/prohibit';
import svgPushPinSimpleSlash from '@components/icons/svgs/push-pin-simple-slash';
import svgPushPinSimple from '@components/icons/svgs/push-pin-simple';
import svgQrCode from '@components/icons/svgs/qr-code';
import svgQuestion from '@components/icons/svgs/question';
import svgQueue from '@components/icons/svgs/queue';
import svgRadar from '@components/icons/svgs/radar';
import svgRadioButtonFill from '@components/icons/svgs/radio-button-fill';
import svgRadioButton from '@components/icons/svgs/radio-button';
import svgRecord from '@components/icons/svgs/record';
import svgRepeatOnce from '@components/icons/svgs/repeat-once';
import svgRepeat from '@components/icons/svgs/repeat';
import svgReposicaoEletrolitica from '@components/icons/svgs/reposicao-eletrolitica';
import svgRewind from '@components/icons/svgs/rewind';
import svgRewind1 from '@components/icons/svgs/rewind1';
import svgRiscoCirurgico from '@components/icons/svgs/risco-cirurgico';
import svgRocketLaunch from '@components/icons/svgs/rocket-launch';
import svgRss from '@components/icons/svgs/rss';
import svgRuler from '@components/icons/svgs/ruler';
import svgScissors from '@components/icons/svgs/scissors';
import svgScreencast from '@components/icons/svgs/screencast';
import svgSealCheck from '@components/icons/svgs/seal-check';
import svgSemiologia from '@components/icons/svgs/semiologia';
import svgShareFat from '@components/icons/svgs/share-fat';
import svgShareNetwork from '@components/icons/svgs/share-network';
import svgShieldCheck from '@components/icons/svgs/shield-check';
import svgShieldCheckered from '@components/icons/svgs/shield-checkered';
import svgShieldSlash from '@components/icons/svgs/shield-slash';
import svgShoppingBag from '@components/icons/svgs/shopping-bag';
import svgShoppingCart from '@components/icons/svgs/shopping-cart';
import svgShuffle from '@components/icons/svgs/shuffle';
import svgSidebarSimple from '@components/icons/svgs/sidebar-simple';
import svgSignIn from '@components/icons/svgs/sign-in';
import svgSignOut from '@components/icons/svgs/sign-out';
import svgSkipBack from '@components/icons/svgs/skip-back';
import svgSkipForward from '@components/icons/svgs/skip-forward';
import svgSlidersHorizontal from '@components/icons/svgs/sliders-horizontal';
import svgSliders from '@components/icons/svgs/sliders';
import svgSomeCheckboxFill from '@components/icons/svgs/some-checkbox-fill';
import svgSortAscending from '@components/icons/svgs/sort-ascending';
import svgSortDescending from '@components/icons/svgs/sort-descending';
import svgSparkle from '@components/icons/svgs/sparkle';
import svgSpeakerHigh from '@components/icons/svgs/speaker-high';
import svgSpeakerLow from '@components/icons/svgs/speaker-low';
import svgSpeakerNone from '@components/icons/svgs/speaker-none';
import svgSpeakerSimpleX from '@components/icons/svgs/speaker-simple-x';
import svgSpeakerSlash from '@components/icons/svgs/speaker-slash';
import svgSpinnerGap from '@components/icons/svgs/spinner-gap';
import svgSquaresFour from '@components/icons/svgs/squares-four';
import svgStack from '@components/icons/svgs/stack';
import svgStarHalf from '@components/icons/svgs/star-half';
import svgStar from '@components/icons/svgs/star';
import svgStorefront from '@components/icons/svgs/storefront';
import svgSun from '@components/icons/svgs/sun';
import svgSus from '@components/icons/svgs/sus';
import svgTextAlignCenter from '@components/icons/svgs/text-align-center';
import svgTextAlignJustify from '@components/icons/svgs/text-align-justify';
import svgTextAlignLeft from '@components/icons/svgs/text-align-left';
import svgTextAlignRight from '@components/icons/svgs/text-align-right';
import svgTextAunderline from '@components/icons/svgs/text-aunderline';
import svgTextB from '@components/icons/svgs/text-b';
import svgTextColumns from '@components/icons/svgs/text-columns';
import svgTextHfour from '@components/icons/svgs/text-hfour';
import svgTextHone from '@components/icons/svgs/text-hone';
import svgTextHthree from '@components/icons/svgs/text-hthree';
import svgTextHtwo from '@components/icons/svgs/text-htwo';
import svgTextIndent from '@components/icons/svgs/text-indent';
import svgTextItalic from '@components/icons/svgs/text-italic';
import svgTextOutdent from '@components/icons/svgs/text-outdent';
import svgTextStrikethrough from '@components/icons/svgs/text-strikethrough';
import svgTextUnderline from '@components/icons/svgs/text-underline';
import svgThumbsDown from '@components/icons/svgs/thumbs-down';
import svgThumbsUp from '@components/icons/svgs/thumbs-up';
import svgTicket from '@components/icons/svgs/ticket';
import svgTimerFill from '@components/icons/svgs/timer-fill';
import svgTimer from '@components/icons/svgs/timer';
import svgTrash from '@components/icons/svgs/trash';
import svgTrauma from '@components/icons/svgs/trauma';
import svgTray from '@components/icons/svgs/tray';
import svgTrendDown from '@components/icons/svgs/trend-down';
import svgTrendUp from '@components/icons/svgs/trend-up';
import svgTrophy from '@components/icons/svgs/trophy';
import svgTuss from '@components/icons/svgs/tuss';
import svgUploadSimple from '@components/icons/svgs/upload-simple';
import svgUsb from '@components/icons/svgs/usb';
import svgUserCheck from '@components/icons/svgs/user-check';
import svgUserCircle from '@components/icons/svgs/user-circle';
import svgUserList from '@components/icons/svgs/user-list';
import svgUserPlus from '@components/icons/svgs/user-plus';
import svgUserSound from '@components/icons/svgs/user-sound';
import svgUser from '@components/icons/svgs/user';
import svgUsers from '@components/icons/svgs/users';
import svgVacinacao from '@components/icons/svgs/vacinacao';
import svgVault from '@components/icons/svgs/vault';
import svgVideoCameraSlash from '@components/icons/svgs/video-camera-slash';
import svgVideoCamera from '@components/icons/svgs/video-camera';
import svgVisa from '@components/icons/svgs/visa';
import svgWarehouse from '@components/icons/svgs/warehouse';
import svgWarningCircle from '@components/icons/svgs/warning-circle';
import svgWarning from '@components/icons/svgs/warning';
import svgWaveformSlash from '@components/icons/svgs/waveform-slash';
import svgWaveform from '@components/icons/svgs/waveform';
import svgWheelchair from '@components/icons/svgs/wheelchair';
import svgWifiHigh from '@components/icons/svgs/wifi-high';
import svgWrench from '@components/icons/svgs/wrench';
import svgXcircle from '@components/icons/svgs/xcircle';
import svgSidebarSimpleFilled from '@components/icons/svgs/side-bar-simple-filled';
import svgRocket from '@components/icons/svgs/rocket-fly';
import svgMedicine from '@components/icons/svgs/medicine';
import svgNewspaper from '@components/icons/svgs/newspaper';
import svgFacebook from '@components/icons/svgs/facebook';
import svgInstagram from '@components/icons/svgs/instagram';
import svgLinkedin from '@components/icons/svgs/linkedin';
import svgX from '@components/icons/svgs/x';
import svgYoutube from '@components/icons/svgs/youtube';
import svgArrow from '@components/icons/svgs/arrow';
import svgDoctor from '@components/icons/svgs/doctor';
import svgPen from '@components/icons/svgs/pen';

export const ICONS_MAPPING = {
  'address-book-tabs': svgAddressBookTabs,
  'administracao-de-drogas': svgAdministracaoDeDrogas,
  airplay: svgAirplay,
  'align-bottom': svgAlignBottom,
  'align-center-horizontal': svgAlignCenterHorizontal,
  'align-center-vertical': svgAlignCenterVertical,
  'align-left': svgAlignLeft,
  'align-right': svgAlignRight,
  rocket: svgRocket,
  'align-top': svgAlignTop,
  american: svgAmerican,
  anestesiologia: svgAnestesiologia,
  armchair: svgArmchair,
  'arrow-arc-left': svgArrowArcLeft,
  'arrow-arc-right': svgArrowArcRight,
  'arrow-bend-up-left': svgArrowBendUpLeft,
  'arrow-bend-up-right': svgArrowBendUpRight,
  'arrow-clockwise': svgArrowClockwise,
  'arrow-counter-clockwise': svgArrowCounterClockwise,
  'arrow-down-left': svgArrowDownLeft,
  'arrow-down-right': svgArrowDownRight,
  'arrow-down': svgArrowDown,
  'arrow-elbow-down-left': svgArrowElbowDownLeft,
  'arrow-elbow-down-right': svgArrowElbowDownRight,
  'arrow-elbow-up-left': svgArrowElbowUpLeft,
  'arrow-elbow-up-right': svgArrowElbowUpRight,
  'arrow-left': svgArrowLeft,
  'arrow-right': svgArrowRight,
  'arrow-square-out': svgArrowSquareOut,
  'arrow-up-left': svgArrowUpLeft,
  'arrow-up-right': svgArrowUpRight,
  'arrow-up': svgArrowUp,
  'arrows-clockwise': svgArrowsClockwise,
  'arrows-counter-clockwise': svgArrowsCounterClockwise,
  'arrows-down-up': svgArrowsDownUp,
  'arrows-in-line-vertical': svgArrowsInLineVertical,
  'arrows-in-simple': svgArrowsInSimple,
  'arrows-left-right': svgArrowsLeftRight,
  'arrows-out-cardinal': svgArrowsOutCardinal,
  'arrows-out-line-vertical': svgArrowsOutLineVertical,
  'arrows-out-simple': svgArrowsOutSimple,
  'arrows-out': svgArrowsOut,
  at: svgAt,
  'atlas-de-dermatologia': svgAtlasDeDermatologia,
  'atlas-de-radiologia': svgAtlasDeRadiologia,
  'atlas-oftalmologia': svgAtlasOftalmologia,
  'atlas-ortopedia': svgAtlasOrtopedia,
  baby: svgBaby,
  barcode: svgBarcode,
  basket: svgBasket,
  'battery-charging': svgBatteryCharging,
  'battery-full': svgBatteryFull,
  'battery-high': svgBatteryHigh,
  'battery-low': svgBatteryLow,
  'battery-medium': svgBatteryMedium,
  'bell-ringing': svgBellRinging,
  'bell-slash': svgBellSlash,
  'bell-z': svgBellZ,
  bell: svgBell,
  'bluetooth-off': svgBluetoothOff,
  bluetooth: svgBluetooth,
  'book-open-text': svgBookOpenText,
  book: svgBook,
  'bookmark-simple': svgBookmarkSimple,
  broom: svgBroom,
  browsers: svgBrowsers,
  'building-office': svgBuildingOffice,
  buildings: svgBuildings,
  'calculadoras-escores': svgCalculadorasEscores,
  'calculadoras-obstetricas': svgCalculadorasObstetricas,
  'calculadoras-pediatricas': svgCalculadorasPediatricas,
  'calendar-blank': svgCalendarBlank,
  'calendar-check': svgCalendarCheck,
  'calendar-dots': svgCalendarDots,
  'calendar-plus': svgCalendarPlus,
  'calendar-slash': svgCalendarSlash,
  'camera-rotate': svgCameraRotate,
  'camera-slash': svgCameraSlash,
  camera: svgCamera,
  cardholder: svgCardholder,
  'cards-three': svgCardsThree,
  'caret-down': svgCaretDown,
  'caret-left': svgCaretLeft,
  'caret-right': svgCaretRight,
  'caret-up-down': svgCaretUpDown,
  'caret-up': svgCaretUp,
  'cell-signal-full': svgCellSignalFull,
  'cell-signal-off': svgCellSignalOff,
  'chart-bar-horizontal': svgChartBarHorizontal,
  'chart-bar': svgChartBar,
  'chart-donut': svgChartDonut,
  'chart-line-down': svgChartLineDown,
  'chart-line-up': svgChartLineUp,
  'chart-pie-slice': svgChartPieSlice,
  'chart-scatter': svgChartScatter,
  'chat-circle-dots': svgChatCircleDots,
  'chat-circle': svgChatCircle,
  'chat-teardrop-slash': svgChatTeardropSlash,
  'chats-circle': svgChatsCircle,
  'check-circle': svgCheckCircle,
  check: svgCheck,
  'checkbox-fill': svgCheckboxFill,
  checkbox: svgCheckbox,
  checks: svgChecks,
  cid: svgCid,
  'circle-notch': svgCircleNotch,
  circuitry: svgCircuitry,
  'clinical-drops': svgClinicalDrops,
  'clock-countdown-fill': svgClockCountdownFill,
  'clock-countdown': svgClockCountdown,
  'clock-counter-clockwise': svgClockCounterClockwise,
  'clock-fill': svgClockFill,
  clock: svgClock,
  close: svgClose,
  'closed-captioning': svgClosedCaptioning,
  'cloud-arrow-down': svgCloudArrowDown,
  'cloud-arrow-up': svgCloudArrowUp,
  'cloud-slash': svgCloudSlash,
  cloud: svgCloud,
  'codigo-de-etica': svgCodigoDeEtica,
  coins: svgCoins,
  compass: svgCompass,
  'condutas-cirurgicas': svgCondutasCirurgicas,
  'condutas-ginecologicas': svgCondutasGinecologicas,
  'condutas-pediatricas': svgCondutasPediatricas,
  'contactless-payment': svgContactlessPayment,
  cookie: svgCookie,
  copy: svgCopy,
  copyright: svgCopyright,
  'corners-out': svgCornersOut,
  couch: svgCouch,
  'credit-card': svgCreditCard,
  'criterios-diagnosticos': svgCriteriosDiagnosticos,
  crop: svgCrop,
  'crown-simple': svgCrownSimple,
  cube: svgCube,
  'cuidados-paleativos': svgCuidadosPaleativos,
  'currency-btc': svgCurrencyBtc,
  'currency-circle-dollar-fill': svgCurrencyCircleDollarFill,
  'currency-circle-dollar': svgCurrencyCircleDollar,
  'currency-dollar-simple': svgCurrencyDollarSimple,
  'currency-eur': svgCurrencyEur,
  'currency-gbp': svgCurrencyGbp,
  'cursor-text': svgCursorText,
  cursor: svgCursor,
  database: svgDatabase,
  'decision-tracks': svgDecisionTracks,
  desktop: svgDesktop,
  'device-mobile-speaker': svgDeviceMobileSpeaker,
  'device-tablet-speaker': svgDeviceTabletSpeaker,
  devices: svgDevices,
  'diagnostico-diferencial': svgDiagnosticoDiferencial,
  dinners: svgDinners,
  documentosAtestados: svgDocumentosAtestados,
  'dots-six-vertical': svgDotsSixVertical,
  'dots-six': svgDotsSix,
  'dots-three-vertical': svgDotsThreeVertical,
  'dots-three': svgDotsThree,
  'download-simple': svgDownloadSimple,
  'drag-handle': svgDragHandle,
  drop: svgDrop,
  'ear-slash': svgEarSlash,
  eject: svgEject,
  elo: svgElo,
  emergenciasUti: svgEmergenciasUti,
  'envelope-open': svgEnvelopeOpen,
  'envelope-simple': svgEnvelopeSimple,
  equalizer: svgEqualizer,
  eraser: svgEraser,
  'exames-complementares': svgExamesComplementares,
  export: svgExport,
  'eye-closed': svgEyeClosed,
  'eye-slash': svgEyeSlash,
  eye: svgEye,
  'eyedropper-sample': svgEyedropperSample,
  eyedropper: svgEyedropper,
  facebook: svgFacebook,
  factory: svgFactory,
  'fast-forward': svgFastForward,
  'file-plus': svgFilePlus,
  'file-text': svgFileText,
  file: svgFile,
  'film-reel': svgFilmReel,
  'film-slate': svgFilmSlate,
  'film-strip': svgFilmStrip,
  fingerprint: svgFingerprint,
  flag: svgFlag,
  'flip-horizontal': svgFlipHorizontal,
  'flip-vertical': svgFlipVertical,
  'folder-open': svgFolderOpen,
  'folder-plus': svgFolderPlus,
  'folder-simple-lock': svgFolderSimpleLock,
  folder: svgFolder,
  'frame-corners': svgFrameCorners,
  'funnel-simple-x': svgFunnelSimpleX,
  'funnel-simple': svgFunnelSimple,
  'funnel-x': svgFunnelX,
  funnel: svgFunnel,
  'gauge-fill': svgGaugeFill,
  gauge: svgGauge,
  gear: svgGear,
  'gender-female': svgGenderFemale,
  'gender-intersex': svgGenderIntersex,
  'gender-male': svgGenderMale,
  'gender-neuter': svgGenderNeuter,
  'gender-nonbinary': svgGenderNonbinary,
  'gender-transgender': svgGenderTransgender,
  'gerenciador-de-plantao': svgGerenciadorDePlantao,
  gift: svgGift,
  'globe-hemisphere-west': svgGlobeHemisphereWest,
  globe: svgGlobe,
  glossario: svgGlossario,
  'gps-fix': svgGpsFix,
  'gps-slash': svgGpsSlash,
  'guia-de-antimicrobianos': svgGuiaDeAntimicrobianos,
  'guia-de-ecg': svgGuiaDeEcg,
  'guia-de-procedimentos': svgGuiaDeProcedimentos,
  'guia-de-vm': svgGuiaDeVm,
  'guia-intoxicacao': svgGuiaIntoxicacao,
  'guia-usg-beira-leito': svgGuiaUsgBeiraLeito,
  'hand-pointing': svgHandPointing,
  'hard-drives': svgHardDrives,
  headphones: svgHeadphones,
  'heart-half': svgHeartHalf,
  heart: svgHeart,
  'hourglass-medium-fill': svgHourglassMediumFill,
  'hourglass-medium': svgHourglassMedium,
  house: svgHouse,
  image: svgImage,
  'images-square': svgImagesSquare,
  info: svgInfo,
  infusao: svgInfusao,
  instagram: svgInstagram,
  'interacao-medicamentosa': svgInteracaoMedicamentosa,
  'intercorrencias-obstetricias': svgIntercorrenciasObstetricias,
  key: svgKey,
  keyhole: svgKeyhole,
  laboratorio: svgLaboratorio,
  laptop: svgLaptop,
  'lightbulb-filament': svgLightbulbFilament,
  'lightning-slash': svgLightningSlash,
  lightning: svgLightning,
  'link-break': svgLinkBreak,
  link: svgLink,
  linkedin: svgLinkedin,
  'list-bullets': svgListBullets,
  list: svgList,
  'lock-key-open': svgLockKeyOpen,
  'lock-key': svgLockKey,
  'logo-wb': svgLogoWb,
  'magic-wand': svgMagicWand,
  'magnifying-glass-minus': svgMagnifyingGlassMinus,
  'magnifying-glass-plus': svgMagnifyingGlassPlus,
  'magnifying-glass': svgMagnifyingGlass,
  manipulados: svgManipulados,
  'map-pin-area': svgMapPinArea,
  'map-pin': svgMapPin,
  'map-trifold': svgMapTrifold,
  master: svgMaster,
  medicamentos: svgMedicamentos,
  medicine: svgMedicine,
  'medicina-de-familia': svgMedicinaDeFamilia,
  'medicina-esporte': svgMedicinaEsporte,
  'medicina-interna': svgMedicinaInterna,
  megaphone: svgMegaphone,
  'microphone-slash': svgMicrophoneSlash,
  microphone: svgMicrophone,
  'minus-circle': svgMinusCircle,
  minus: svgMinus,
  moon: svgMoon,
  mouse: svgMouse,
  'music-notes': svgMusicNotes,
  'navigation-arrow': svgNavigationArrow,
  'newspaper-clipping': svgNewspaperClipping,
  newspaper: svgNewspaper,
  notches: svgNotches,
  'note-blank': svgNoteBlank,
  'note-pencil': svgNotePencil,
  note: svgNote,
  numpad: svgNumpad,
  nut: svgNut,
  oftalmologia: svgOftalmologia,
  'orientacao-ao-paciente': svgOrientacaoAoPaciente,
  ortopedia: svgOrtopedia,
  otorrinolaringologia: svgOtorrinolaringologia,
  package: svgPackage,
  'paint-brush-broad': svgPaintBrushBroad,
  'paint-bucket': svgPaintBucket,
  'paint-roller': svgPaintRoller,
  palette: svgPalette,
  'paper-plane-tilt': svgPaperPlaneTilt,
  paperclip: svgPaperclip,
  paragraph: svgParagraph,
  'parto-epuerperio': svgPartoEpuerperio,
  'pause-circle': svgPauseCircle,
  pause: svgPause,
  'pencil-simple': svgPencilSimple,
  'phone-call': svgPhoneCall,
  'phone-disconnect': svgPhoneDisconnect,
  'phone-outgoing': svgPhoneOutgoing,
  'phone-slash': svgPhoneSlash,
  'phone-transfer': svgPhoneTransfer,
  'phone-x': svgPhoneX,
  'piggy-bank': svgPiggyBank,
  'play-circle': svgPlayCircle,
  'play-pause': svgPlayPause,
  play: svgPlay,
  playlist: svgPlaylist,
  'plus-circle': svgPlusCircle,
  plus: svgPlus,
  podcast: svgPodcast,
  power: svgPower,
  'pre-natal': svgPreNatal,
  'prescicoes-cirurgicas': svgPrescicoesCirurgicas,
  prescricao: svgPrescricao,
  'prescricoes-pediatricas': svgPrescricoesPediatricas,
  'prescritor-de-antibiotico': svgPrescritorDeAntibiotico,
  'procedimentos-pediatricos': svgProcedimentosPediatricos,
  'produtos-farmaceuticos': svgProdutosFarmaceuticos,
  prohibit: svgProhibit,
  'push-pin-simple-slash': svgPushPinSimpleSlash,
  'push-pin-simple': svgPushPinSimple,
  'qr-code': svgQrCode,
  question: svgQuestion,
  queue: svgQueue,
  radar: svgRadar,
  'radio-button-fill': svgRadioButtonFill,
  'radio-button': svgRadioButton,
  record: svgRecord,
  'repeat-once': svgRepeatOnce,
  repeat: svgRepeat,
  'reposicao-eletrolitica': svgReposicaoEletrolitica,
  rewind: svgRewind,
  rewind1: svgRewind1,
  'risco-cirurgico': svgRiscoCirurgico,
  'rocket-launch': svgRocketLaunch,
  rss: svgRss,
  ruler: svgRuler,
  scissors: svgScissors,
  screencast: svgScreencast,
  'seal-check': svgSealCheck,
  semiologia: svgSemiologia,
  'share-fat': svgShareFat,
  'share-network': svgShareNetwork,
  'shield-check': svgShieldCheck,
  'shield-checkered': svgShieldCheckered,
  'shield-slash': svgShieldSlash,
  'shopping-bag': svgShoppingBag,
  'shopping-cart': svgShoppingCart,
  shuffle: svgShuffle,
  'sidebar-simple': svgSidebarSimple,
  'sidebar-simple-filled': svgSidebarSimpleFilled,
  'sign-in': svgSignIn,
  'sign-out': svgSignOut,
  'skip-back': svgSkipBack,
  'skip-forward': svgSkipForward,
  'sliders-horizontal': svgSlidersHorizontal,
  sliders: svgSliders,
  'some-checkbox-fill': svgSomeCheckboxFill,
  'sort-ascending': svgSortAscending,
  'sort-descending': svgSortDescending,
  sparkle: svgSparkle,
  'speaker-high': svgSpeakerHigh,
  'speaker-low': svgSpeakerLow,
  'speaker-none': svgSpeakerNone,
  'speaker-simple-x': svgSpeakerSimpleX,
  'speaker-slash': svgSpeakerSlash,
  'spinner-gap': svgSpinnerGap,
  'squares-four': svgSquaresFour,
  stack: svgStack,
  'star-half': svgStarHalf,
  star: svgStar,
  storefront: svgStorefront,
  sun: svgSun,
  sus: svgSus,
  'text-align-center': svgTextAlignCenter,
  'text-align-justify': svgTextAlignJustify,
  'text-align-left': svgTextAlignLeft,
  'text-align-right': svgTextAlignRight,
  'text-aunderline': svgTextAunderline,
  'text-b': svgTextB,
  'text-columns': svgTextColumns,
  'text-hfour': svgTextHfour,
  'text-hone': svgTextHone,
  'text-hthree': svgTextHthree,
  'text-htwo': svgTextHtwo,
  'text-indent': svgTextIndent,
  'text-italic': svgTextItalic,
  'text-outdent': svgTextOutdent,
  'text-strikethrough': svgTextStrikethrough,
  'text-underline': svgTextUnderline,
  'thumbs-down': svgThumbsDown,
  'thumbs-up': svgThumbsUp,
  ticket: svgTicket,
  'timer-fill': svgTimerFill,
  timer: svgTimer,
  trash: svgTrash,
  trauma: svgTrauma,
  tray: svgTray,
  'trend-down': svgTrendDown,
  'trend-up': svgTrendUp,
  trophy: svgTrophy,
  tuss: svgTuss,
  'upload-simple': svgUploadSimple,
  usb: svgUsb,
  'user-check': svgUserCheck,
  'user-circle': svgUserCircle,
  'user-list': svgUserList,
  'user-plus': svgUserPlus,
  'user-sound': svgUserSound,
  user: svgUser,
  users: svgUsers,
  vacinacao: svgVacinacao,
  vault: svgVault,
  'video-camera-slash': svgVideoCameraSlash,
  'video-camera': svgVideoCamera,
  visa: svgVisa,
  warehouse: svgWarehouse,
  'warning-circle': svgWarningCircle,
  warning: svgWarning,
  'waveform-slash': svgWaveformSlash,
  waveform: svgWaveform,
  wheelchair: svgWheelchair,
  'wifi-high': svgWifiHigh,
  wrench: svgWrench,
  x: svgX,
  xcircle: svgXcircle,
  youtube: svgYoutube,
  arrow: svgArrow,
  doctor: svgDoctor,
  pen: svgPen,
};
